module.exports = __webpack_public_path__ + "img/yellow.681191b2.png";